import React from 'react';
import ReactDOM from 'react-dom';
import {ConfigProvider} from "antd";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import './index.less';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/locale/zh_CN';
import en_US from 'antd/lib/locale/en_US';
import moment from 'moment';

ReactDOM.render(    
    // <ConfigProvider locale={zh_CN}>
    //     <HashRouter>
            <App />,
    //     </HashRouter>
    // </ConfigProvider>,
    document.getElementById('root')
);

reportWebVitals();
